import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=1987dace&scoped=true"
import script from "./step5.vue?vue&type=script&lang=js"
export * from "./step5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987dace",
  null
  
)

export default component.exports